export default "__VITE_ASSET__Ckl7$XRf__"